import { Helmet } from 'react-helmet-async';
import useFetch from '../useFetch';

function SEO({ title, description, image }) {
    const { data } = useFetch(`${process.env.REACT_APP_BACKEND}/api/seo?populate=*`)

    const seoData = data?.data?.attributes || {}
    const resolvedTitle = title || seoData.Title || 'Cause Lab'
    const resolvedDescription = description || seoData.Description || ''
    const resolvedImage = image || seoData.Preview_image?.data?.attributes?.url || ''

    
    if (data) {
        console.log(data)
        return (
            <Helmet>
                <title>{resolvedTitle}</title>
                <meta name="description" content={resolvedDescription} />
                {resolvedImage && <meta property="og:image" content={resolvedImage} />}
                <meta property="og:title" content={resolvedTitle} />
                <meta property="og:description" content={resolvedDescription} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={resolvedTitle} />
                <meta name="twitter:description" content={resolvedDescription} />
                {resolvedImage && <meta name="twitter:image" content={resolvedImage} />}
            </Helmet>
        );
    }
    
}

export default SEO;
